import rot13Cipher from 'rot13-cipher'

// Encoding UTF8 ⇢ base64
const aa =
  'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9eyJwYXlsb2FkIjoiMTM5ODM0IiwiaWF0IjoxNjQwMTg2NTE4LCJleHAiOjE2NDAxOTY1MTgsImF1ZCI6Imh0dHBzOi8vd3d3LmZ3ZC5jby50aCIsImlzcyI6IkZXRFRoYWlsYW5kIiwic3ViIjoic29tYm9vbi5rQGZ3ZC5jb20ifQ'
export function b64EncodeUnicode(str: any) {
  return crypt(
    aa,
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
    })
  )
}

// Decoding base64 ⇢ UTF8

export function b64DecodeUnicode(str: any) {
  return decodeURIComponent(
    Array.prototype.map
      .call(decrypt(aa, str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
}

const crypt = (salt: any, text: any) => {
  const textToChars = (text: any) => text.split('').map((c: any) => c.charCodeAt(0))
  const byteHex = (n: number) => ('0' + Number(n).toString(16)).substr(-2)
  const applySaltToChar = (code: any) => textToChars(salt).reduce((a: any, b: any) => a ^ b, code)

  return text.split('').map(textToChars).map(applySaltToChar).map(byteHex).join('')
}

const decrypt = (salt: any, encoded: any) => {
  const textToChars = (text: any) => text.split('').map((c: any) => c.charCodeAt(0))
  const applySaltToChar = (code: any) => textToChars(salt).reduce((a: any, b: any) => a ^ b, code)
  return encoded
    .match(/.{1,2}/g)
    .map((hex: any) => parseInt(hex, 16))
    .map(applySaltToChar)
    .map((charCode: any) => String.fromCharCode(charCode))
    .join('')
}

export const encryptQueryString = (encoded: any) => {
  const base64Str = window.btoa(JSON.stringify(encoded))
  return rot13Cipher(base64Str)
}

export const decodeToken = (token: string) => {
  const base64 = token.split('.')[1]
  return JSON.parse(atob(base64).toString())
}
